export enum TrackedPage {
    // Main viewmodels
    WorkspaceDashboard, //done
    NewStorymap, //done
    ManageStorymapsEditStorymap, //done

    Storymap, // not
    ManageStorymaps, //done
    ManagePersonas, //not
    ManagePeople, //not
    UpgradeSubscription, //TODO
    ManageJiraIntegrationSettings, //done
    WorkspaceAccessHistory, //done
    WorkspaceAuditLog, //done
    StorymapCardDetails, //not

    // Workspaces viewmodels
    UserDashboard, //done
    DomainControl, //done
    NewWorkspace, //done
    ControlledDomainAccounts, //done

    SignupSuccess, //done

    UserProfile, //done
    DataCollectionPreferences, //done

    ClaimDomain, //done
    VerifyDomainOwnership, //done
    ConfigureControlledDomain, //done

    FindStorymapsOnDashboard, //done

    StroymapSearchAndFilter, //not
    StorymapPersonas, //not
    StorymapActivityFeed, //not
    StorymapTrashedItems, //not
    StorymapNotifications, //not
    StorymapDirectMessageNotifications, //not
    StorymapShare, //not
    StorymapMoreSharing, //not
    StorymapExport, //not
    StorymapArchiveReleases, //not
    StorymapBoardSettings, //not
    StorymapIssueTrackerSettings, //not
    StorymapTeamChatSettings, //not
    StorymapKeyboardShortcuts, //not
    StorymapReleaseDetails, //not
    StorymapReleaseReports, //not
    StorymapAnnotations, //not
    StorymapBoardDiscussion, //not
    StorymapBoardAttachments, //not

    ManagePeopleInvite, //done

    ManageStorymapCollections, //done
    ManageStorymapCollectionsAddNew, //done

    WorkspaceDetails, //done
    WorkspaceAdvancedSecurity, //done
    WorkspacePlansAndBilling, //done
    WorkspaceClose, //done

    UpgradeSubscriptionPaymentForm, //TODO
    UpgradeSubscriptionSuccess, //TODO

    UserNotificationSettings, //done
    UserDashboardNotifications, //TODO
    UserDashboardDirectMessageNotifications, //TODO

    WorkspaceDashboardNotifications, //TODO
    WorkspaceDashboardDirectMessageNotifications, //TODO

    FeedbackPortalInsights, //TODO
    FeedbackPortalIdeas, //TODO
    FeedbackPortalRoadmap, //TODO
    FeedbackPortalIdeaPortal, //TODO

    ProductDashboard,
    ManageProducts,
    ManageStorymapTemplates, //done

    Ai, //TODO
}
